import Menu from 'advanced-menus';
import Vue from 'vue';

import { Initializer } from '../interfaces/general';

export default class MainMenuInitializer implements Initializer {
  public mount($: JQueryStatic, app: Vue) {
    // new FixedOnScroll("header#main", 100);

    new Menu({
      options: {
        parent_clickable: true,
        disable_scroll: true
      },
      selectors: {
        toggle_button: ".toggle-mainmenu-button"
      },
      events: {
        // events: {
        //   swipeLeft: function(menu, e) {
        //     menu.close();
        //   },
        //   swipeRight: function(menu, e) {
        //     if (e.touches[0].clientX < 50) {
        //       menu.open();
        //     }
        //   }
        // }
      }
    });
  }

  public unmount() {
    // nope
  }
}
